// @vendors
import { useMemo, useState } from 'react'

// @context
import { useUI } from '../../../app/context/ui';

// @service
import ClientServiceNewApi from '../../../services/AppServiceClient/ClientService';

// @helpers
import AppHelper from '../../../helpers/AppHelper';

const useClients = (organizationId) => {
  const clientService = useMemo(() => new ClientServiceNewApi(), []);
  const { blockUI, snackbarUI } = useUI();

  const [rowsState, setRowsState] = useState({
      pageSize: 10,
      rows: [],
      rowCount: 0,
      currentPage: 0,
      page: 0,
      filters: { name: ''}
  });

  const getAllClients = async (params) => {
      const pagination = {page: params?.page ?? 1, size: params?.size ?? rowsState.pageSize};
      const filters = params?.filters || rowsState.filters;
      try {
          blockUI.current.open(true);
          const response = await clientService.getClients(organizationId, pagination, filters);
          successRequestCompanies(response);
      } catch (error) {
          blockUI.current.open(false);
          AppHelper.checkError(error, snackbarUI);
      }
  }

  const successRequestCompanies = (response) => {
    blockUI.current.open(false);
    const data = response?.data;
    setRowsState((prev) => ({
        ...prev,
        pageSize: data?.pagination?.page_size || 10,
        rows: data?.data || [],
        rowCount: data?.pagination?.total_records || 0,
        currentPage: data?.pagination?.page_number,
        page: data?.pagination?.page_number -1,
    }));
  }

  return {
    getAllClients,
    rowsState,
    setRowsState
  }
}

export default useClients